import { default as _91_46_46_46slug_93r52dtZ6YuXMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/[...slug].vue?macro=true";
import { default as _404npvmCRJS38Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/404.vue?macro=true";
import { default as indexKr10qbvspqMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/arbochecklist/index.vue?macro=true";
import { default as bedankt9KhQuL88vtMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/bedankt.vue?macro=true";
import { default as _91slug_938NlKLcavTvMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/contact/[slug].vue?macro=true";
import { default as indexOpUJEMQFujMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/contact/index.vue?macro=true";
import { default as indexwiSRNqLDyhMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93xlDpKhLfv2Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/nieuws/[slug].vue?macro=true";
import { default as indexRuGajTlhX0Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/nieuws/index.vue?macro=true";
import { default as open_45sollicitatieFy32qDo7g2Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/open-sollicitatie.vue?macro=true";
import { default as _91_46_46_46slug_931ln8h7gDn7Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/over-westerduin/[...slug].vue?macro=true";
import { default as _91slug_93Dke6Pjn3ooMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/referenties/[slug].vue?macro=true";
import { default as indexpsFxD1f4tvMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/referenties/index.vue?macro=true";
import { default as vacatures_45als_45_91slug_93IIKQS75I89Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures-als-[slug].vue?macro=true";
import { default as vacatures_45bij_45_91slug_93CMXZLgG5h0Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures-bij-[slug].vue?macro=true";
import { default as vacatures_45in_45_91slug_93b4sn6IkMQqMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures-in-[slug].vue?macro=true";
import { default as _91slug_934ORSZHKea5Meta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures/[slug].vue?macro=true";
import { default as index2HX6sD21LIMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures/index.vue?macro=true";
import { default as vragenbr4I59nynuMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vragen.vue?macro=true";
import { default as _91_46_46_46slug_93UmtI6WMHyyMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/[...slug].vue?macro=true";
import { default as bedankt1TPico7buoMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/bedankt.vue?macro=true";
import { default as faqr6oMkAFkuAMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/faq.vue?macro=true";
import { default as registratie_45inlenersbeloning1sV6eqQzpBMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue?macro=true";
import { default as werkwijzehaaP2pCYFTMeta } from "/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkwijze.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93r52dtZ6YuXMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "arbochecklist",
    path: "/arbochecklist",
    meta: indexKr10qbvspqMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/arbochecklist/index.vue").then(m => m.default || m)
  },
  {
    name: "bedankt",
    path: "/bedankt",
    meta: bedankt9KhQuL88vtMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "contact-slug",
    path: "/contact/:slug()",
    meta: _91slug_938NlKLcavTvMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/contact/[slug].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexOpUJEMQFujMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexwiSRNqLDyhMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug()",
    meta: _91slug_93xlDpKhLfv2Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/nieuws/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nieuws",
    path: "/nieuws",
    meta: indexRuGajTlhX0Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/nieuws/index.vue").then(m => m.default || m)
  },
  {
    name: "open-sollicitatie",
    path: "/open-sollicitatie",
    meta: open_45sollicitatieFy32qDo7g2Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/open-sollicitatie.vue").then(m => m.default || m)
  },
  {
    name: "over-westerduin-slug",
    path: "/over-westerduin/:slug(.*)*",
    meta: _91_46_46_46slug_931ln8h7gDn7Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/over-westerduin/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties-slug",
    path: "/referenties/:slug()",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/referenties/[slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties",
    path: "/referenties",
    meta: indexpsFxD1f4tvMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/referenties/index.vue").then(m => m.default || m)
  },
  {
    name: "vacatures-als-slug",
    path: "/vacatures-als-:slug()",
    meta: vacatures_45als_45_91slug_93IIKQS75I89Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures-als-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-bij-slug",
    path: "/vacatures-bij-:slug()",
    meta: vacatures_45bij_45_91slug_93CMXZLgG5h0Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures-bij-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-in-slug",
    path: "/vacatures-in-:slug()",
    meta: vacatures_45in_45_91slug_93b4sn6IkMQqMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures-in-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-slug",
    path: "/vacatures/:slug()",
    meta: _91slug_934ORSZHKea5Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures",
    path: "/vacatures",
    meta: index2HX6sD21LIMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vacatures/index.vue").then(m => m.default || m)
  },
  {
    name: "vragen",
    path: "/vragen",
    meta: vragenbr4I59nynuMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/vragen.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-slug",
    path: "/werkgevers/:slug(.*)*",
    meta: _91_46_46_46slug_93UmtI6WMHyyMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-bedankt",
    path: "/werkgevers/bedankt",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-faq",
    path: "/werkgevers/faq",
    meta: faqr6oMkAFkuAMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/faq.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-registratie-inlenersbeloning",
    path: "/werkgevers/registratie-inlenersbeloning",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue").then(m => m.default || m)
  },
  {
    name: "werkwijze",
    path: "/werkwijze",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/28/nuxt/pages/werkwijze.vue").then(m => m.default || m)
  }
]